module.exports = __webpack_public_path__ + "img/rootstock.6f6a53dd.svg";